import { easternDay } from '../../modules/q2c/eastern-day.mjs';

// Lead ages count the partners' Eastern calendar days, not elapsed 24-hour periods.
// An unreadable timestamp has no age label and returns ''.
export function leadAge(iso, now = new Date()) {
  const createdDay = easternDay(iso);
  const currentDay = easternDay(now);
  if (createdDay === '' || currentDay === '') return '';

  const d = (Date.parse(`${currentDay}T00:00:00Z`) - Date.parse(`${createdDay}T00:00:00Z`)) / 86400000;
  if (d <= 0) return 'today';
  if (d === 1) return '1d';
  if (d < 30) return `${d}d`;
  return `${Math.floor(d / 30)}mo`;
}
